import { z } from 'my-zod'

export const programAgreementAdditionalSigner = z.object({
  programAgreementId: z.string().uuid(),
  outfitterContactId: z
    .string({
      invalid_type_error: 'Required',
      required_error: 'Required'
    })
    .uuid('Required'),
  email: z
    .string({
      invalid_type_error: 'Required',
      required_error: 'Required'
    })
    .min(1, 'Required')
})

export type programAgreementAdditionalSigner = z.infer<typeof programAgreementAdditionalSigner>
